import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { Seo } from '@hero/atoms';

import { routes } from './routes';
import { RouteProvider, lazyLoadComponent } from './utils';

export const RenderRoutes = () => {
  const renderRoutes = routeObject =>
    routeObject.map((route, index) => {
      const { children, path, element, middlewares = [], props, state, ...rest } = route;

      const RenderElement = () => <React.Fragment>{element}</React.Fragment>;

      const renderMiddlewares = () => {
        if (!middlewares || middlewares.length === 0) {
          return <RenderElement />;
        }
        return middlewares.reduce(
          (acc, middleware, index) => {
            const { provider } = middleware;
            return lazyLoadComponent(provider, {
              props: { children: acc, ...props },
              key: `${path}-${index}`
            });
          },
          <RenderElement />
        );
      };

      if (children) {
        return (
          <Route {...rest} key={`${route.path} ${index}`} path={path} element={element}>
            {renderRoutes(children)}
          </Route>
        );
      }

      return (
        <Route
          {...rest}
          key={`${route.path} ${index}`}
          path={path}
          element={
            <RouteProvider {...state} path={path}>
              <Seo {...state?.metadata} />
              {renderMiddlewares()}
            </RouteProvider>
          }
        />
      );
    });

  return <Routes>{renderRoutes(routes)}</Routes>;
};
